import React from 'react'
import TextInput from '../form/TextInput'
import FileInput from '../form/FileInput'
import { SketchPicker } from 'react-color';
import GlobalStorage from '../storage/GlobalStorage'
import {Collapse,ButtonGroup,Button} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight,faCaretDown} from '@fortawesome/free-solid-svg-icons'




export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      open:""
    }
    this.GS = new GlobalStorage();    
  }

  
  render()
  {
    var {
      character
    } = this.props;

    var t = this;
    
    return (        
        <div class="accordion">
            <div class="card">
              <h5 class="card-header">                      
                  <button class="btn btn-link" type="button" onClick={()=>
                  {
                    if (this.state.open=='characterBox')
                      this.setState({open:""});
                    else
                    this.setState({open:"characterBox"});
                  }}>
                    角色 {this.state.open=="characterBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}
                  </button>                
              </h5>                                  
              <Collapse isOpen={this.state.open=="characterBox"}>
                <div class="card-body">
                  <p>
                    <label>角色名稱</label>
                    <input type={`text`}
                          value={this.props.character.id}
                          onChange={(e) => {
                            this.props.character.id = e.target.value;
                            t.forceUpdate();
                            
                          }}/>                        
                  </p>
                  <p>
                    <label>文字顏色</label><br/><br/>
                    <SketchPicker
                    disableAlpha={true}   
                      presetColors={['#FFFFFF','#FF0000','#00FF00','#0000FF']}             
                          color={character.name.color}
                          onChangeComplete={function(color,e){
                            character.name.color = color.hex;
                            t.forceUpdate();
                            
                          }}            
                      />      
                  </p>

                  <p>                          
                    <ButtonGroup>
                      <div class="input-group-prepend">
                        <div class="input-group-text">文字大小</div>
                      </div>        
                      <Button color="primary" onClick={() => {this.props.character.name.size = 'small';t.forceUpdate();}} active={this.props.character.name.size === 'small'}>小</Button>
                      <Button color="primary" onClick={() => {this.props.character.name.size = 'medium';t.forceUpdate();}} active={this.props.character.name.size === 'medium'}>中</Button>
                      <Button color="primary" onClick={() => {this.props.character.name.size = 'large';t.forceUpdate();}} active={this.props.character.name.size === 'large'}>大</Button>
                      <Button color="primary" onClick={() => {this.props.character.name.size = 'xlarge';t.forceUpdate();}} active={this.props.character.name.size ==='xlarge'}>特大</Button>
                    </ButtonGroup>
                  </p>

                  <p>                          
                    <ButtonGroup>
                      <div class="input-group-prepend">
                        <div class="input-group-text">字體粗細</div>
                      </div>        
                      <Button color="primary" onClick={() => {this.props.character.name.style = 'light';t.forceUpdate();}} active={this.props.character.name.style === 'light'}>幼體</Button>                            
                      <Button color="primary" onClick={() => {this.props.character.name.style = 'regular';t.forceUpdate();}} active={this.props.character.name.style === 'regular'}>正常</Button>
                      <Button color="primary" onClick={() => {this.props.character.name.style = 'bold';t.forceUpdate();}} active={this.props.character.name.style === 'bold'}>粗體</Button>                            
                    </ButtonGroup>
                  </p>
                </div>
              </Collapse>              
            </div>                
    

            <div class="card">
              <h5 class="card-header">
                <button class="btn btn-link" type="button" onClick={()=>
                  {
                    if (this.state.open=='contentBox')
                      this.setState({open:""});
                    else
                    this.setState({open:"contentBox"});
                  }}>
                  內文 {this.state.open=="contentBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}
                </button>
              </h5>                                        
              <Collapse isOpen={this.state.open=="contentBox"}>
                <div class="card-body">                      
                  <p>
                    <label>內文顏色</label><br/><br/>
                    <SketchPicker   
                        disableAlpha={true}             
                        color={this.props.character.text.color}
                        presetColors={["#000000","#FFFFFF",'#666666', '#FF0000']}
                        onChangeComplete={function(color,e){
                          character.text.color = color.hex;                                
                          
                        }}            
                    />
                  </p>

                  <p>                         
                    <ButtonGroup>
                      <div class="input-group-prepend">
                        <div class="input-group-text">文字大小</div>
                      </div>        
                      <Button color="primary" onClick={() => {this.props.character.text.size = 'small';t.forceUpdate();}} active={this.props.character.text.size === 'small'}>小</Button>
                      <Button color="primary" onClick={() => {this.props.character.text.size = 'medium';t.forceUpdate();}} active={this.props.character.text.size === 'medium'}>中</Button>
                      <Button color="primary" onClick={() => {this.props.character.text.size = 'large';t.forceUpdate();}} active={this.props.character.text.size === 'large'}>大</Button>
                      <Button color="primary" onClick={() => {this.props.character.text.size = 'xlarge';t.forceUpdate();}} active={this.props.character.text.size ==='xlarge'}>特大</Button>
                    </ButtonGroup>                          
                  </p>

                  <p>                          
                    <ButtonGroup>
                      <div class="input-group-prepend">
                        <div class="input-group-text">字體粗細</div>
                      </div>        
                      <Button color="primary" onClick={() => {this.props.character.text.style = 'light';t.forceUpdate();}} active={this.props.character.text.style === 'light'}>幼體</Button>                            
                      <Button color="primary" onClick={() => {this.props.character.text.style = 'regular';t.forceUpdate();}} active={this.props.character.text.style === 'regular'}>正常</Button>
                      <Button color="primary" onClick={() => {this.props.character.text.style = 'bold';t.forceUpdate();}} active={this.props.character.text.style === 'bold'}>粗體</Button>                            
                    </ButtonGroup>
                  </p>
                </div>
              </Collapse>
            </div>                

            <div class="card">
              <h5 class="card-header">
                <button class="btn btn-link" type="button" onClick={()=>{
                    if (this.state.open=='dialogueBox')
                      this.setState({open:""});
                    else
                    this.setState({open:"dialogueBox"});
                  }}
                  >
                  對話框 {this.state.open=="dialogueBox"?(<FontAwesomeIcon icon={faCaretDown} className={"ml-2"}/>):(<FontAwesomeIcon icon={faCaretRight} className={"ml-2"}/>)}
                </button>
              </h5>     
              <Collapse isOpen={this.state.open=="dialogueBox"}>
                <div class="card-body">
                  <p>
                    <label>對話框顏色</label><br/><br/>
                    <SketchPicker                   
                        disableAlpha={true}
                        presetColors={['#666666','#FFFFFF','#f8f2c6', '#ddf8c6', '#ffc1c5', '#c6f0f8']}             
                        color={this.props.character.bubble_color}
                        onChangeComplete={function(color,e){
                          character.bubble_color = color.hex;                            
                          t.forceUpdate();
                        }}            
                    />
                  </p>                      
                  </div>
              </Collapse>
            </div>               
        </div>
  )}
}